/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */
const menuInit = () => {
  const dropdowns = document.querySelectorAll(
    '.menu .menu__item--has-children, .menu .menu__item--submenu--has-children',
  );
  const headerMenu: HTMLElement = document.querySelector('.header__menu');
  const backString = headerMenu.dataset.back;

  const submenuClasses = {
    active: 'submenu__list--active',
    hidden: 'submenu__list--hidden',
  };

  const toggleSubmenu = (item: HTMLElement) => {
    const submenu: HTMLElement = item.querySelector('.submenu__list');
    submenu.classList.toggle(submenuClasses.active);
    item.classList.toggle('menu__item--active');

    // Check if item has closest submenu
    const closestSubmenu = item.closest('.submenu__list');

    if (!closestSubmenu) return;

    closestSubmenu.scrollTop = 0;
    closestSubmenu.classList.toggle(submenuClasses.hidden);
  };

  const submenuHtml = (item) => {
    const menuLink = item.querySelector('.menu__link');
    const submenu: HTMLElement = item.querySelector('.submenu__list');

    // Prepend title to the submenu
    const anchor = menuLink.cloneNode(true);
    anchor.classList.add('menu__link--title');
    submenu?.insertAdjacentElement('afterbegin', anchor);

    // Prepend the back button to the submenu
    const backElement = document.createElement('span');
    backElement.innerHTML = backString;
    backElement.classList.add('menu__back');
    submenu?.insertAdjacentElement('afterbegin', backElement);

    // Create back elements
    backElement.addEventListener('click', () => toggleSubmenu(item));
  };

  const removeActiveItems = () => {
    dropdowns?.forEach((menuItem) => menuItem.classList.remove('menu__item--active'));
  };

  dropdowns?.forEach((menuItem: HTMLElement) => {
    // Build the extra html on the submenu
    submenuHtml(menuItem);

    // If the menuItem has been clicked, prevent the menu from being redirected;
    const menuLink = menuItem.querySelector(
      '.menu__link:not(.menu__link--title)',
    );

    menuLink?.addEventListener('click', (event) => {
      const active = menuItem.classList.contains('menu__item--active');

      event.preventDefault();

      // Open the submenu
      if (active) {
        menuItem.classList.remove('menu__item--active');
      } else {
        removeActiveItems();
        toggleSubmenu(menuItem);
      }
    });
  });
};

export default menuInit;
